import { FC, Suspense } from 'react'
import useFeatureFlags from 'hooks/useFeatureFlags'
import Field from '../../../../components/fields'
import styled from 'styled-components'

type Props = {
  homeSettings: any
  formId: string
}

export const QuickLogSettings: FC<Props> = ({ homeSettings, formId }) => {
  const flags = useFeatureFlags({
    flagNames: ['clinical_safety_seizures'],
  })?.data

  return (
    <FiedWrapper>
      <Suspense fallback={<div>Loading...</div>}>
        <Field
          keys="logCategoryItems"
          displayLabel={false}
          formId={formId}
          type="logCategoryItems"
          values={homeSettings}
          hideShortSeizure={flags?.clinical_safety_seizures?.enabled}
        />
      </Suspense>
    </FiedWrapper>
  )
}

const FiedWrapper = styled.div`
  padding-top: 12px;
`
